import { calculateScore } from './calculateScore';

export const buildPcModelAttrs = (options) => {
  const allAttrTags = options?.flatMap((option) => {
    const {
      tags: [attrTags],
    } = option;
    return attrTags;
  });

  const pcModelAttrs = [];

  allAttrTags?.forEach((attrTag) => {
    const existingTag = pcModelAttrs?.find((item) => item.name === attrTag.name);

    if (!existingTag) pcModelAttrs?.push(determineAttrTag(options, attrTag));
  });

  return pcModelAttrs;
};

const determineAttrTag = (options, attrTag) => {
  const isScoreAttrTag = attrTag?.name.startsWith('score_');

  if (isScoreAttrTag) {
    return {
      name: attrTag.name,
      value: calculateScore(options, attrTag.name),
    };
  }

  return attrTag;
};
